import { render, staticRenderFns } from "./StageMenu.vue?vue&type=template&id=6596c417"
import script from "./StageMenu.vue?vue&type=script&lang=js"
export * from "./StageMenu.vue?vue&type=script&lang=js"
import style0 from "./StageMenu.vue?vue&type=style&index=0&id=6596c417&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports